<template>
  <b-modal
    id="modal-excluir-nfe"
    ref="modal"
    size="md"
    hide-header
    hide-footer
    body-class="p-0 overflow-hidden"
    content-class="border-0 shadow-lg"
    no-close-on-backdrop
    centered
  >
    <!-- Cabeçalho Premium -->
    <div class="modal-header-premium p-3 d-flex align-items-center" 
         style="background: linear-gradient(135deg, #f86c6b 0%, #f03e3e 100%) !important;">
      <div class="header-icon-wrapper mr-3 bg-white-10 text-center rounded p-2" style="width: 48px; height: 48px;">
        <i class="fa fa-trash-o text-white fa-lg"></i>
      </div>
      <div>
        <h5 class="mb-0 font-weight-bold text-white">Exclusão de NF-e</h5>
        <small class="text-white opacity-75">Confirme a exclusão deste registro</small>
      </div>
      <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="fechar">
        <i class="fa fa-times fa-lg"></i>
      </b-button>
    </div>

    <div class="p-4" v-if="nfe">
      <!-- Barra de Informações -->
      <div class="modal-info-bar mb-4 bg-light border shadow-sm p-3 rounded">
        <b-row>
          <b-col cols="12" class="mb-2">
            <small class="text-muted font-weight-bold text-uppercase d-block mb-1">Destinatário</small>
            <h6 class="mb-0 font-weight-bold text-dark text-truncate">{{ nfe.TX_NOME_CLIENTE || nfe.NOME_CLIENTE || 'Não informado' }}</h6>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6" class="border-right">
            <small class="text-muted font-weight-bold text-uppercase d-block mb-1">NF-e / Série</small>
            <h6 class="mb-0 font-weight-bold text-primary">{{ nfe.TX_NUM_NFE || '---' }} / {{ nfe.ID_SERIE || '-' }}</h6>
          </b-col>
          <b-col cols="6" class="text-right">
            <small class="text-muted font-weight-bold text-uppercase d-block mb-1">Valor Total</small>
            <h6 class="mb-0 font-weight-bold text-success">{{ formatCurrency(nfe.VL_TOTAL_NFE) }}</h6>
          </b-col>
        </b-row>
        <b-row class="mt-2 text-center">
            <b-col>
                <b-badge :variant="colorirSITUACAO(nfe.OP_STATUS)" class="px-3 py-2 mt-2">
                    {{ nfe.OP_STATUS_TRADUZIDO }}
                </b-badge>
            </b-col>
        </b-row>
      </div>

      <!-- Alert informativo -->
      <b-alert show variant="warning" class="rounded-lg border-0 shadow-sm mb-0">
        <div class="d-flex align-items-center">
          <i class="fa fa-exclamation-triangle mr-3 fa-lg text-warning"></i>
          <div>
            <strong class="d-block text-dark">Atenção</strong>
            <span class="small text-muted">Esta ação remove o registro do sistema (altera status para Excluído) e não comunica a SEFAZ.</span>
          </div>
        </div>
      </b-alert>
    </div>

    <!-- Rodapé Premium -->
    <div class="modal-footer-premium p-3 bg-light d-flex justify-content-end border-top">
      <b-button variant="light" @click="fechar" class="mr-2 rounded-pill px-4 shadow-sm font-weight-bold">
        Cancelar
      </b-button>
      <b-button 
        variant="danger" 
        @click="confirmarExclusao"
        :disabled="processando"
        class="rounded-pill px-4 shadow-sm font-weight-bold"
      >
        <b-spinner small v-if="processando" class="mr-1" />
        <i class="fa fa-trash-o mr-1" v-else></i> Confirmar Exclusão
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import Tools from '@/tools/tools.js'

export default {
  name: 'ExcluirNfeModal',
  
  data() {
    return {
      nfe: null,
      processando: false
    }
  },

  methods: {
    abrir(nfe) {
      this.nfe = nfe
      this.processando = false
      this.$refs.modal.show()
    },

    fechar() {
      this.$refs.modal.hide()
      this.nfe = null
      this.processando = false
    },

    async confirmarExclusao() {
      this.processando = true
      
      try {
        const payload = {
          nfeId: this.nfe.ID,
          login: window.localStorage.getItem('login') || 'sistema'
        }

        const response = await this.$http.post('/api/protected/notaFiscal/excluir', payload)
        
        // Supondo que a API retorna sucesso simples ou estrutura padrao
        // O response.data geralmente é o objeto de retorno
        const resultado = response.data

        // Verifica sucesso
        if (resultado && (resultado.sucesso || resultado.status === 200 || resultado === true)) { // Adapte conforme padrao da API se souber
             // Se a API retorna void 200 OK, ou { sucesso: true }
             // Assumindo padrao do projeto (baseado no context de CancelarNfeModal)
             if (resultado.sucesso === false) {
                 throw new Error(resultado.erro || resultado.mensagem || 'Erro ao excluir NF-e')
             }

             Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'NF-e excluída com sucesso')
             this.$emit('nfe-excluida', { nfeId: this.nfe.ID })
             this.fechar()
        } else {
             // Caso a API retorne algo que não indique sucesso claro
             const erro = resultado?.erro || resultado?.mensagem || 'Erro desconhecido ao excluir'
             if (resultado && resultado.sucesso === undefined) {
                 // Se nao tem campo sucesso, talvez o proprio result seja ok?
                 // Mas normalmente tem.
                 Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'NF-e excluída com sucesso')
                 this.$emit('nfe-excluida', { nfeId: this.nfe.ID })
                 this.fechar()
             } else {
                 Tools.exibirMensagem(this.$store, 'Erro', 'danger', erro)
             }
        }

      } catch (err) {
        console.error('Erro ao excluir NF-e:', err)
        const msg = err.response?.data?.erro || err.response?.data?.mensagem || err.message || 'Falha na exclusão'
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', msg)
      } finally {
        this.processando = false
      }
    },

    formatCurrency(val) { return Tools.formatCurrency(val) },
    
    colorirSITUACAO(s) {
      if (!s) return 'secondary'
      const txt = String(s).toUpperCase()
      if (txt.includes('2')) return 'success'
      if (txt.includes('3')) return 'danger'
      if (txt.includes('5')) return 'warning'
      if (txt.includes('1')) return 'info'
      return 'secondary'
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/faturamento/nfe/partials/ExcluirNfeModal.vue